import "./cookie-consent-overlay.js";
import "./menu.js";
import "./menu-animations";
import "./additional-filter-toggle.js";
import "./header-scroll.js";
import "./status-messages.js";
import "./search";
import "./slider.js";
import "./takeover";
import slick from "slick-carousel";
import "./customEuCookieComplianceBehaviour";
import "./convertTopLevelMenuItemsToHeadings.js";

// Polyfill: missing forEach on NodeList for IE11
if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = Array.prototype.forEach;
}

import $ from "jquery";
import MainMenu from "./menu.js";
let bibuBehaviorHasRun = false;

Drupal.behaviors.bibu = {
  attach: function (context) {
    if (!bibuBehaviorHasRun) {
      const menuItems = document.querySelectorAll(
        ".header__second-inner > div > nav .menu__item--has-children > a",
        context
      );
      new MainMenu(menuItems);
      bibuBehaviorHasRun = true;
    }
  },
};

/* Drupal.behaviors.responsiveIframe = { What is this for?
  attach: function (context) {
    // Find all iframes
    let $iframes = $("iframe");

    $iframes.each(function () {
      $(this).wrap('<div class="iframe-container"></div>');
    });
  },
};
 */
